<template>

    <div>
        <template v-if="method === 'swish'">
            <div class="orange-payment-method-expanded">

                <!-- Swish: Step 1 -->
                <div v-if="! waitingOnSwish">
                    <div>
                        <span class="text-sm text-gray-400 mb-1 block">Ange det nummer du har kopplat till Swish</span>
                        <card-input label="" v-model="swishPhoneNumber" />
                    </div>

                    <div class="text-center mt-4 mb-2">
                        <button class="mt-8 mb-6 mb-2 py-2 px-6 bg-blue-600 text-white text-center rounded-full w-32 disabled:bg-gray-300 disabled:cursor-not-allowed" @click="payWithSwish">
                            Fortsätt
                        </button>
                    </div>
                </div>

                <!-- Swish: Step 2 -->
                <div v-if="waitingOnSwish">
                    <div>
                        <img class="mx-auto" :src="`${publicPath}/images/swish.png`" alt="Swish">
                    </div>

                    <div class="text-base text-gray-400 mt-8">Starta Swish på den enhet du har appen installerad för att slutföra din betalning</div>

                    <div class="my-8">
                        <div class="payment-spinner payment-spinner-blue">
                            <div class="payment-bounce1"></div>
                            <div class="payment-bounce2"></div>
                            <div class="payment-bounce3"></div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>

</template>

<script>
    import axios from 'axios'
    import CardRadio from "./CardRadio";
    import CardInput from "./CardInput";
    import OrangePaymentStripePaymentIntent from "./OrangePaymentStripePaymentIntent";

    export default {
        components: {OrangePaymentStripePaymentIntent, CardRadio, CardInput},
        props: ['api', 'name', 'orderId', 'method'],
        data() {
            return {
                publicPath: process.env.VUE_APP_BASE_URL,
                statusTimer: null,
                swishPhoneNumber: null,
                waitingOnSwish: false,
            }
        },
        watch: {
            method: {
                handler: async function(val, oldVal) {
                    if (val !== 'swish') {
                        this.waitingOnSwish = false
                    }
                }
            }
        },
        methods: {
            async payWithSwish() {
                this.waitingOnSwish = true

                let response = await axios.post(`${this.api}/swish/init`, { order_id: this.orderId, phone_number: this.swishPhoneNumber })

                if (response.data.request.error) {
                    alert(response.data.request.error)
                    this.waitingOnSwish = false

                    return
                }

                // Wait for Swish to confirm the order
                this.statusTimer = window.setInterval(() => {
                    this.checkStatus()
                }, 2000)
            },
            async checkStatus() {
                let response = await axios.get(`${this.api}/swish/check?order_id=${this.orderId}`)

                if (response.data.paid) {
                    window.clearInterval(this.statusTimer)
                    this.$emit('success')
                } else if (response.data.error) {
                    alert('Något gick fel, vi kunde inte ta emot din betalning')
                    window.clearInterval(this.statusTimer)
                }
            }
        }
    }
</script>

<style type="text/css">
    .orange-payment-method-expanded {
        padding-top: 22px;
        padding-left: 28px;
        padding-right: 28px;
    }
</style>